module.exports = __webpack_public_path__ + "static/waltz-krem-rolls-narandza-6282b8af49bc07ef4fe6f6bdd092e4a2.jpg";